export default {"src":"/_next/static/image/public/images/ic_video_upload_doc_blue.d0bdba6b1b8700eef89cc34013be7ff4.svg","height":56,"width":56};